import { render, staticRenderFns } from "./appBaseConfig.vue?vue&type=template&id=9aab16cc&"
import script from "./appBaseConfig.vue?vue&type=script&lang=js&"
export * from "./appBaseConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9aab16cc')) {
      api.createRecord('9aab16cc', component.options)
    } else {
      api.reload('9aab16cc', component.options)
    }
    module.hot.accept("./appBaseConfig.vue?vue&type=template&id=9aab16cc&", function () {
      api.rerender('9aab16cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/app/appBaseConfig/appBaseConfig.vue"
export default component.exports